import React, { useState, useEffect } from "react";
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import styles from "./About.module.css";
import ArrowBounce from "./ArrowBounce";

import data from "./aboutData";

const About = () => {
  const [index, setIndex] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [isHovering, setIsHovering] = useState(false);

  const { ref, inView } = useInView({
    triggerOnce: false,
  });

  const modulo = (a, b) => {
    let result = a % b;
    return result >= 0 ? result : result + b;
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (!isPaused) {
        setIndex((index + 1) % data.length);
      }
    }, 3000);

    return () => {
      clearTimeout(timeout);
    };
  }, [index, isPaused]);

  const handleCardClick = () => {
    setIsPaused(!isPaused);
  };

  const handleMouseEnter = (i) => {
    if (i === index) {
      setIsPaused(true);
    }
    setIsHovering(i === index);
  };

  const handleMouseLeave = () => {
    setIsPaused(false);
    setIsHovering(false);
  };

  const handleSlideNext = () => {
    setIndex((index + 1) % data.length);
  };

  const handleSlidePrevious = () => {
    setIndex(modulo(index - 1, data.length));
  };

  const variants = {
    hidden: { opacity: 0, x: inView ? "100%" : "-100%" },
    visible: { opacity: 1, x: "0%" },
  };

  return (
    <motion.section
      ref={ref}
      initial="hidden"
      animate={inView ? "visible" : "hidden"}
      variants={variants}
      transition={{ duration: 1.5 }}
    >
      <div className={styles.container}>
        <div className={styles.aboutContainer}>
          <div className={styles.demoContainer}>
            <h1 className={styles.cardTitle}>Demo</h1>
            <p>
              Welcome to the interactive demo of our innovative scheduling
              application! Take a virtual tour and experience the power of our
              platform firsthand. In this demo, you'll get a glimpse of how our
              scheduling solution can transform the way you plan and manage your
              time.
              <br /> Feel free to customize and adapt this text to match the
              specifics of your application and its features.
            </p>
          </div>

          <div className={styles.cardsContainer}>
            {data.map((item, i) => {
              let className = styles.card;

              if (i === index) {
                className += ` ${styles.card_middle}`;
              } else if (i === modulo(index + 1, data.length)) {
                className += ` ${styles.card_left}`;
              } else if (i === modulo(index - 1, data.length)) {
                className += ` ${styles.card_right}`;
              }

              return (
                <div
                  key={item.id}
                  className={className}
                  onClick={handleCardClick}
                  onMouseEnter={() => handleMouseEnter(i)}
                  onMouseLeave={handleMouseLeave}
                >
                  <h1 className={styles.cardTitle}>{item.title}</h1>
                  {isHovering && i === index && (
                    <div className={styles.tooltip}>
                      <p>{item.text}</p>
                    </div>
                  )}
                  {i === index && !isHovering && (
                    <ArrowBounce isVisible={!isHovering} />
                  )}
                  {item.image && (
                    <img
                      src={item.image}
                      alt={item.title}
                      className={styles.cardImage}
                    />
                  )}
                </div>
              );
            })}
            <div className={styles.buttonContainer}>
              <button className={styles.icon} onClick={handleSlidePrevious}>
                <FiArrowLeft />
              </button>
              <button className={styles.icon} onClick={handleSlideNext}>
                <FiArrowRight />
              </button>
            </div>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

export default About;
